// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from "@/store/index";
import Vant, { Lazyload, Toast } from "vant";
import clipboardCopy from "clipboard-copy";
import "vant/lib/index.css";
import 'vant/lib/icon/local.css';//本地
import "@/libs/rem";
import "@/assets/style.less";
import VueTouch from 'vue-touch';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import {getEncryCode , sendEncryCode} from "@/api/jsencryptKey"
import { HappyScroll } from 'vue-happy-scroll'
import './assets/aliicon/iconfont.css'
import wx from 'weixin-js-sdk'
import utils from '@/utils/utils.js'
import Mui from 'vue-awesome-mui';
Vue.use(Mui);
// 引入css
import 'vue-happy-scroll/docs/happy-scroll.css'
// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
//自定义组件名
Vue.component('happy-scroll', HappyScroll)
Vue.use(VueAwesomeSwiper)
Vue.prototype.$host = 'http://php.ymzb98.com/'

Vue.prototype.$copy = clipboardCopy;
Vue.prototype.$toast = Toast
Vue.use(Lazyload);
Vue.use(Vant);
Vue.component("Navs", () =>
    import ("@/components/common/nav"));
Vue.component("Tabbar", () =>
    import ("@/components/common/tabbar.vue"));
	Vue.component("TabbarGroup", () =>
	    import ("@/components/common/tabbarGroup.vue"));
Vue.component("Main", () =>
    import ("@/components/common/main.vue"));
Vue.config.productionTip = false
import { mixin } from '@/libs/mixin'
Vue.mixin(mixin)
    /* eslint-disable no-new */
import waterfall from 'vue-waterfall2'
import vueMiniPlayer from 'vue-mini-player'
import 'vue-mini-player/lib/vue-mini-player.css'
Vue.use(vueMiniPlayer)
import FileUpload from 'vue-file-upload';
Vue.component('file-upload', FileUpload);
Vue.use(waterfall)
Vue.prototype.goBackPage = function () {
　　window.history.go(-1)
}
	
new Vue({
    el: '#app',
    router,
	data:function(){
		return{
			imgurl:'https://cdn.ycylwz.com/',
		}
	},
    store,
    components: { App },
    template: '<App/>',
	mounted()  {
		var that=this
		window.apiready = function() {
			Vue.prototype.isapp = 'app';
			var wxPlus= api.require('wxPlus');
				Vue.prototype.wxPlus= wxPlus;
			var UIChatBox = api.require('UIChatBox');
				Vue.prototype.UIChatBox= UIChatBox;
			var agoraRtc = api.require('agoraRtc');
				Vue.prototype.agoraRtc= agoraRtc;
			var aliPayPlus = api.require('aliPayPlus');
				Vue.prototype.aliPayPlus= aliPayPlus;
			var ajpush = api.require('ajpush');
				Vue.prototype.ajpush = ajpush;
			var wxPayPlus = api.require('wxPayPlus');
				Vue.prototype.wxPayPlus = wxPayPlus;
			var imrCamera = api.require('imrCamera');
				Vue.prototype.imrCamera = imrCamera;
			var videoTool = api.require('videoTools');
				Vue.prototype.videoTool = videoTool;
			var mp3Recorder = api.require('mp3Recorder');
				Vue.prototype.mp3Recorder = mp3Recorder;
		}
	},
	//实例化之后触发事件
	created() {	
		
	},
})




// WEBPACK FOOTER //
// ./src/main.js